import { useEffect, useState } from "react";

const links = [
  { href: "#library", label: "画风库" },
  { href: "#style-guide", label: "画风推荐" },
  { href: "#popular", label: "热门精选" },
  { href: "#wiki", label: "画风百科" },
  { href: "#faq", label: "常见问题" },
  { href: "#about", label: "关于漫屿" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || open;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        solid ? "bg-background-50/95 backdrop-blur border-b border-background-200 shadow-soft" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 md:h-[72px] max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2.5" aria-label="漫屿 首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-brush-2-line text-lg" aria-hidden="true"></i>
          </span>
          <span
            className={`font-heading text-xl md:text-2xl tracking-wide transition-colors ${
              solid ? "text-foreground-900" : "text-white"
            }`}
          >
            漫屿
          </span>
        </a>

        <div className={`hidden items-center gap-1 lg:flex`}>
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className={`whitespace-nowrap rounded-md px-3 py-2 text-sm transition-colors ${
                solid ? "text-foreground-700 hover:text-primary-600 hover:bg-background-100" : "text-white/90 hover:text-white hover:bg-white/10"
              }`}
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="hidden lg:flex items-center gap-2">
          <a
            href="#library"
            className="whitespace-nowrap rounded-full bg-primary-500 px-5 py-2 text-sm font-medium text-background-50 transition hover:bg-primary-600"
          >
            开始筛选
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className={`flex h-10 w-10 items-center justify-center rounded-md lg:hidden ${
            solid ? "text-foreground-800 hover:bg-background-100" : "text-white hover:bg-white/10"
          }`}
          aria-label="打开菜单"
          aria-expanded={open}
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl`} aria-hidden="true"></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-2 lg:hidden">
          <div className="flex flex-col gap-1">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="whitespace-nowrap rounded-md px-3 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-600"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#library"
              onClick={() => setOpen(false)}
              className="mt-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-center text-sm font-medium text-background-50 transition hover:bg-primary-600"
            >
              开始筛选
            </a>
          </div>
        </div>
      )}
    </header>
  );
}